import { useEffect } from 'react';

import { useIdentity } from '@zenbusiness/application-commons-identity';
import { useIntercom } from '@zenbusiness/application-commons-intercom';

import { identify, unidentify } from '#client/utils/reporting';

const IdentityManager = () => {
  const {
    loading,
    identified,
    user
  } = useIdentity();
  const { update: updateIntercom } = useIntercom();
  useEffect(() => {
    if (loading) return;
    if (identified) {
      // Identify to tracking
      identify(user);

      // Identify to intercom (if needed)
      if (window.intercomSettings?.email !== user?.accountEmail) {
        updateIntercom({
          email: user?.accountEmail,
          name: user?.name,
          creationDate: user?.createdAt,
          user_id: user.userUuid
        });
      }
    } else {
      unidentify();
    }
  }, [loading, identified, user, updateIntercom]);

  if (!identified) {
    return null;
  }

  return (
    <></>
  );
};

export default IdentityManager;
